import { useIntl } from 'react-intl';
export var useRtl = function useRtl() {
  var rtlLanguageCodes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['ar', 'he'];
  var _useIntl = useIntl(),
    locale = _useIntl.locale;
  var isRTL = rtlLanguageCodes.includes(locale);
  return {
    isRTL: isRTL,
    dir: isRTL ? 'rtl' : 'ltr',
    transformRTL: function transformRTL(a, b) {
      return isRTL ? b : a;
    }
  };
};